var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m225.434-145.304 41.131-164.087H105.869l19.522-79.218h161.261l45.913-182.782H171.869l19.522-79.218h161.261l40.13-164.087h78.784l-40.131 164.087h183.217l40.13-164.087h78.784l-40.131 164.087h161.261l-20.087 79.218H673.913l-46.478 182.782h161.261l-20.087 79.218H607.913l-41.695 164.087h-78.784l41.131-164.087H345.913l-41.695 164.087h-78.784Zm140.001-243.305h183.217l45.913-182.782H411.913l-46.478 182.782Z"
  })));
}
export default SvgTag;